/**
 * Dynamic Mega Menu controller
 * -----------------------------------------------------------
 * Any nav link with:  data-kk-mega-menu-trigger="Menu Name"
 * opens the mega-menu section whose settings.menu_name equals
 * "Menu Name" (exact match, case-insensitive).
 *
 * The mega-menu section must be a positioned descendant of the
 * same header (or given position:relative on its parent) since
 * the panel is position:absolute.
 *
 * When a trigger's panel is open, the trigger itself also gets
 * an "is-open" class (in addition to the panel), so you can
 * style the active nav link — e.g.:
 *   [data-kk-mega-menu-trigger].is-open { color: #000; }
 */
document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('[data-kk-mega-menu-trigger]');
  var panels = document.querySelectorAll('[data-kk-mega-menu]');
  var body = document.body;
  var closeTimer = null;
  var lastX = 0;
  var lastY = 0;
  var activePanel = null;
  var activeTrigger = null;

  document.addEventListener('mousemove', function (e) {
    lastX = e.clientX;
    lastY = e.clientY;
  });

  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }

  function findPanel(name) {
    var target = normalize(name);
    for (var i = 0; i < panels.length; i++) {
      if (normalize(panels[i].getAttribute('data-kk-mega-menu')) === target) {
        return panels[i];
      }
    }
    return null;
  }

  function getHeaderBottom() {
    // All sections in Shopify's header group share this class, including
    // this mega-menu section itself — exclude it and take what's left.
    var groups = document.querySelectorAll('.shopify-section-group-header-group:not(.kk-mega-menu-section)');
    var header = groups[groups.length - 1] || document.querySelector('header');
    if (!header) return 0;
    return Math.round(header.getBoundingClientRect().bottom);
  }

  function openPanel(panel, trigger) {
    clearTimeout(closeTimer);
    panels.forEach(function (p) { p.classList.remove('is-open'); });
    triggers.forEach(function (t) { t.classList.remove('is-open'); });
    body.classList.add('no-scroll');
    if (panel) {
      panel.style.top = getHeaderBottom() + 'px';
      panel.classList.add('is-open');
      if (trigger) trigger.classList.add('is-open');
      activePanel = panel;
      activeTrigger = trigger || null;
    }
  }

  function closeAll() {
    panels.forEach(function (p) { p.classList.remove('is-open'); });
    triggers.forEach(function (t) { t.classList.remove('is-open'); });
    body.classList.remove('no-scroll');
    activePanel = null;
    activeTrigger = null;
  }

  function pointInRect(x, y, rect) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  // Instead of closing on a blind timeout, actually check where the cursor
  // is when the timer fires. If it's still over the trigger, the panel, or
  // the vertical gap directly between them, keep it open. This means a slow
  // or diagonal mouse path from the nav link down into the panel never
  // causes a premature close.
  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (!activePanel) return;

      var panelRect = activePanel.getBoundingClientRect();
      var triggerRect = activeTrigger ? activeTrigger.getBoundingClientRect() : null;

      var overPanel = pointInRect(lastX, lastY, panelRect);
      var overTrigger = triggerRect ? pointInRect(lastX, lastY, triggerRect) : false;

      // "Bridge" zone: the vertical strip between the trigger's horizontal
      // span and the top of the panel, so moving straight down never misses.
      var overBridge = false;
      if (triggerRect) {
        overBridge =
          lastX >= triggerRect.left &&
          lastX <= triggerRect.right &&
          lastY >= triggerRect.top &&
          lastY <= panelRect.top;
      }

      if (overPanel || overTrigger || overBridge) {
        scheduleClose();
      } else {
        closeAll();
      }
    }, 300);
  }

  triggers.forEach(function (trigger) {
    var panel = findPanel(trigger.getAttribute('data-kk-mega-menu-trigger'));
    if (!panel) return;

    trigger.addEventListener('mouseenter', function () {
      openPanel(panel, trigger);
    });
    trigger.addEventListener('focus', function () {
      openPanel(panel, trigger);
    });

    [trigger, panel].forEach(function (el) {
      el.addEventListener('mouseleave', scheduleClose);
      el.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', function () {
    if (activePanel) activePanel.style.top = getHeaderBottom() + 'px';
  });

  document.addEventListener('click', function (e) {
    var withinMenu = e.target.closest('[data-kk-mega-menu], [data-kk-mega-menu-trigger]');
    if (!withinMenu) closeAll();
  });
});